import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { DefineContext } from 'views/DiscretionaryMandate/DefineContext';
import { NewAccountEnum } from 'types';
import { formatEnum } from 'utils/stringUtils';
import { DiscretionaryMandateActions } from 'views/DiscretionaryMandate/DiscretionaryMandateActions';
import { CompatibilityCheckResult } from 'pco-product-service-internal-consumer';
import { checkCompatibility } from 'services/product-service/checkCompatibility';

const styles = {
  container: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
};

type Props = {
  title: string;
  id?: string;
  isPartner: boolean;
  isChange?: boolean;
};
export const DiscretionaryMandate = ({ title, id = '', isPartner, isChange }: Props) => {
  const [fetchedDropDownOptions, setFetchedDropDownOptions] = useState<string[] | null>(null);

  useEffect(() => {
    if (isPartner || isChange || !id) return;

    let ignore = false;
    (async () => {
      try {
        const compatibility: CompatibilityCheckResult = await checkCompatibility(id);
        if (ignore) return;
        setFetchedDropDownOptions(
          compatibility.compatible ? [id, formatEnum(NewAccountEnum.NEW)] : [formatEnum(NewAccountEnum.NEW)],
        );
      } catch {
        if (!ignore) setFetchedDropDownOptions([formatEnum(NewAccountEnum.NEW)]);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [id, isPartner, isChange]);

  const dropDownOptions = isPartner
    ? [formatEnum(NewAccountEnum.NEW)]
    : isChange
      ? [id]
      : (fetchedDropDownOptions ?? []);
  const isLoading = !isPartner && !isChange && fetchedDropDownOptions === null;

  return (
    <>
      <Grid data-testid="discrectionary-manadate" sx={styles.container}>
        <Typography sx={styles.title} variant="h1">
          {`${title} DISCRETIONARY MANDATE`}
        </Typography>
        <DefineContext dropDownOptions={dropDownOptions} isLoading={isLoading} />
      </Grid>
      <DiscretionaryMandateActions />
    </>
  );
};
